import {
  formattedDateOptions,
  formattedYearOptions,
} from '~/javascripts/utils/horizontalDatepickerOptions';
import { observer, useLocalObservable } from 'mobx-react';
import { useEffect, useRef } from 'react';

const BirthdayFields = observer(
  ({
    birthdayPledgeCheckbox,
    countryFromLocale,
    handleBirthdayCheckboxChange,
    place,
    requireBirthday,
  }) => {
    const birthdayCheckboxRef = useRef(null);

    const localStore = useLocalObservable(() => ({
      birthDaySelected: false,
      birthMonthSelected: false,
      birthYearSelected: false,
      birthdayPledgeCheckboxDisabled: true,
    }));

    const MONTHS = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];

    useEffect(() => {
      if (!localStore.birthdayPledgeCheckboxDisabled) {
        birthdayCheckboxRef.current.checked = true;
        handleBirthdayCheckboxChange(true);
      }
    }, [localStore.birthdayPledgeCheckboxDisabled]);

    const birthdaySelectStyleForField = (field) => {
      if (field === 'day' && localStore.birthDaySelected) return {};
      if (field === 'month' && localStore.birthMonthSelected) return {};
      if (field === 'year' && localStore.birthYearSelected) return {};

      return {
        color: '#A1A1AA',
        appearance: 'none',
        backgroundImage:
          "url(\"data:image/svg+xml,%3Csvg fill='%23A1A1AA' viewBox='0 0 20 14' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 0h20L10 14z'/%3E%3C/svg%3E\")",
        backgroundRepeat: 'no-repeat',
      };
    };

    const handleBirthdayChange = (e, inputName) => {
      localStore[`birth${inputName}Selected`] = e.target.value !== '';

      if (birthdayPledgeCheckbox?.show) {
        localStore.birthdayPledgeCheckboxDisabled = !(
          localStore.birthDaySelected ||
          localStore.birthMonthSelected ||
          localStore.birthYearSelected
        );

        if (localStore.birthdayPledgeCheckboxDisabled) {
          birthdayCheckboxRef.current.checked = false;
          handleBirthdayCheckboxChange(false);
        }
      }
    };

    const anyBirthdayFieldFilled = () =>
      localStore.birthDaySelected ||
      localStore.birthMonthSelected ||
      localStore.birthYearSelected;

    const requireBirthdayField = (field) =>
      requireBirthday ||
      (['day', 'month'].includes(field) && anyBirthdayFieldFilled());

    return (
      <div
        className={`birthday-wrapper ${
          place == 'footer' ? '' : 'max-w-xs mx-auto'
        }`}
      >
        <div className='mailing-input-wrapper birthday mt-2 max-w-xs text-left'>
          <label className='show calm-label' htmlFor='birthday'>
            {requireBirthday ? 'Birthday' : 'Birthday (optional)'}
          </label>
        </div>
        <div
          className={`birthday-button-wrapper md-flex ${
            place == 'footer' ? 'items-end' : 'flex-col'
          }`}
        >
          <div className='mailing-input-wrapper birthday max-w-xs md-flex flex-row'>
            <div
              className={`flex flex-auto ${
                countryFromLocale === 'uk' ? 'flex-row-reverse' : 'flex-row'
              }`}
            >
              <select
                className={`border-b-0 md-border-b md-border-r-0 rounded-none ${
                  countryFromLocale === 'uk'
                    ? 'rounded-tr md-rounded-none'
                    : 'border-r-0 rounded-tl md-rounded-l'
                }`}
                data-parsley-error-message='Please provide your birth month'
                data-parsley-errors-container='.birthday-errors-container'
                id='user_birthday_2i'
                name='user[birthday(2i)]'
                onChange={(e) => handleBirthdayChange(e, 'Month')}
                required={requireBirthdayField('month')}
                style={birthdaySelectStyleForField('month')}
              >
                <option value=''>MM</option>
                {MONTHS.map((month, i) => (
                  <option key={month} value={i + 1}>
                    {month}
                  </option>
                ))}
              </select>
              <select
                className={`border-b-0 md-border-b md-border-r-0 rounded-none ${
                  countryFromLocale === 'uk'
                    ? 'border-r-0 rounded-tl md-rounded-l'
                    : 'rounded-tr md-rounded-none'
                }`}
                data-parsley-error-message='Please provide your birth day'
                data-parsley-errors-container='.birthday-errors-container'
                id='user_birthday_3i'
                name='user[birthday(3i)]'
                onChange={(e) => handleBirthdayChange(e, 'Day')}
                required={requireBirthdayField('day')}
                style={birthdaySelectStyleForField('day')}
              >
                <option value=''>DD</option>
                {formattedDateOptions(31)}
              </select>
            </div>
            <select
              className='flex-1 md-rounded-none md-rounded-r rounded-b rounded-none'
              data-parsley-error-message='Please provide your birth year'
              data-parsley-errors-container='.birthday-errors-container'
              id='user_birthday_1i'
              name='user[birthday(1i)]'
              onChange={(e) => handleBirthdayChange(e, 'Year')}
              required={requireBirthdayField('year')}
              style={birthdaySelectStyleForField('year')}
            >
              <option value=''>YYYY</option>
              {formattedYearOptions()}
            </select>
          </div>

          <div className='birthday-errors-container' />
        </div>
        {birthdayPledgeCheckbox?.show && (
          <div className='custom-check mt-2'>
            <input
              disabled={localStore.birthdayPledgeCheckboxDisabled}
              id='birthday-pledge-consent'
              onClick={() =>
                handleBirthdayCheckboxChange(
                  birthdayCheckboxRef.current.checked
                )
              }
              ref={birthdayCheckboxRef}
              type='checkbox'
            />
            <label className='label-2xs' htmlFor='birthday-pledge-consent'>
              Set a reminder to pledge my birthday and help change lives
            </label>
          </div>
        )}
      </div>
    );
  }
);

export default BirthdayFields;
